<app-access-control [notForViewer]="true" [description]="true">
  <ng-container ngProjectAs="[slot][nonViewerContent]">
    @if (wishlist) {
      <div class="wishlist">
        <a class="wishlist__back" routerLink="/wishlists">
          <span class="icon-arrow-left"></span>
          {{ 'wishlists.back' | translate }}
        </a>
        <div class="wishlist__top">
          <div class="wishlist__title">
            <h2 class="title" [attr.data-test]="'desc-wishlistTitle'">{{ wishlist.attributes.name }}</h2>
            <span class="wishlist__time" [attr.data-test]="'desc-wishlistLastUpdate'">
              {{ wishlist.attributes.updatedAt | formatDate }}
              ({{ 'wishlists.last-time' | translate }})
            </span>
          </div>
          <div class="wishlist__actions">
            <div
              class="action__edit"
              [ngClass]="{'disabled': editInProgress}"
              (click)="edit()"
              [attr.data-test]="'button-wishlist-edit'">
              <span class="icon-settings"></span>
              {{ 'wishlists.edit' | translate }}
              @if (editInProgress) {
                <div class="loading-animation"></div>
              }
            </div>
            <div class="action__remove"
              (click)="removeModalActive = true"
              [attr.data-test]="'button-wishlist-remove'">
              <span class="icon-close"></span>
              {{ 'wishlists.remove' | translate }}
            </div>
          </div>
        </div>
        @if (itemsLoaded) {
          @if (wishlistProducts.length > 0) {
            <div class="select">
              <div class="select__all">
                <input
                  type="checkbox"
                  id="select-all"
                  name="select-all"
                  class="checkbox"
                  [checked]="selectAllValue || isAllProductsSelected()"
                  (change)="selectAll($event)"
                  [attr.data-test]="'input-selectAll'">
                <label for="select-all">
                  {{ 'wishlists.select-all' | translate }}
                </label>
              </div>
              <div class="select__actions">
                <div class="select__add-all"
                  [ngClass]="{'disabled': (!areSelectedProductAvailable())}"
                  appDebounceClick
                  (click)="addAllSelectedToCart()"
                  [attr.data-test]="'icon-product-addToCart'">
                  <span class="icon-basket"></span>
                  {{ 'wishlists.add-selected' | translate }}
                </div>
                <div class="select__remove-all"
                  [ngClass]="{'disabled': (selectedProducts.length === 0)}"
                  appDebounceClick
                  (click)="removeAllSelectedItems()"
                  [attr.data-test]="'icon-product-remove-all'">
                  <span class="icon-close"></span>
                  {{ 'wishlists.remove-selected' | translate }}
                </div>
              </div>
            </div>
            <!-- //NOSONAR --><table class="products__table">
            <!-- //Reason why was added here NOSONAR, because <thead> in <table> its not required, in the future we will update rules in SonarQube  -->
            <caption>{{ 'wishlists.products' | translate }}</caption>
            <tbody>
              @for (product of wishlistProducts; track product) {
                <tr class="products__row"
                  [attr.data-test]="'wishlist-item-' + product.name">
                  <td class="col__select">
                    <div class="product__select">
                      <input
                        type="checkbox"
                        [id]="'select-'+product.sku"
                        [name]="'checkbox-'+product.sku"
                        class="checkbox"
                        [checked]="selectedProducts.includes(product.sku)"
                        (change)="selectProduct(product)"
                        [attr.data-test]="'input-select-'+product.sku">
                      <label [for]="'select-'+product.sku"></label>
                    </div>
                  </td>
                  <td class="col__img">
                    <a [routerLink]="['/product/', product.abstractSku]">
                      <img [src]="ImageUtils.addPreset(product.imgUrl, ImagePreset.Thumbnail)" [alt]="product.name" [attr.data-test]="'img-productImage'">
                    </a>
                  </td>
                  <td class="col__title">
                    <a [routerLink]="['/product/', product.abstractSku]"
                    [attr.data-test]="'link-item'">{{ product.name }}</a>
                    @if (isUsStore || isCaStore) {
                      <p class="col__subtitle"
                      [attr.data-test]="'desc-item-sku'">{{ product.materialNumber }}</p>
                    }
                  </td>
                  <div class="display-flex f-align-items-center justify-content-sm-end price-section">
                    @if (isPriceVisible(product.defaultPrice)) {
                      <td class="col__price">
                        {{ PriceUtils.getPriceValue(product.defaultPrice) | currency: currency }}
                        @if (isExcludeTaxActive()) {
                          <a class="col__tax-disclaimer" [attr.data-test]="'wishlist-tax-disclaimer'">
                            ({{ 'app-product-page.ex_gst' | translate }})
                          </a>
                        }
                      </td>
                    }
                    @if (!checkIfProductIsAvailableForOnlinePurchase(product)) {
                      <td>
                        <div class="notification__header" [attr.data-test]="'desc-productIsNotAvailable'">
                          <span class="icon-info icon-info__circle icon-orange-white"></span>
                          <p class="font-weight-bold product-not-available margin-0">
                            {{ 'app-product-page.product-is-not-available-for-online-purchase' | translate }}
                          </p>
                        </div>
                      </td>
                    } @else {
                      @if (!isAddToCartDisabled()) {
                        <td>
                          <div
                            class="display-flex f-align-items-center justify-content-center add-to-cart-section price-section">
                            <div class="col__qty">
                              <input
                                #quantity
                                type="number"
                                [name]="'quantity-'+product.sku"
                                [value]="product.qty"
                                min="1"
                                step="1"
                                class="product__qty--input"
                                [disabled]="isItemInProgress(product.sku)"
                                (change)="updateProductQty(product.sku, quantity.value)"
                                [attr.data-test]="'icon-product-qty'"
                                />
                            </div>
                            <div class="col__menu">
                              <div class="product__menu" [ngClass]="{'disabled': isItemInProgress(product.sku)}">
                                <span
                                  appDebounceClick
                                  [ngClass]="{'disabled': isAddToCartDisabled()}"
                                  [style.visibility]="isItemInProgress(product.sku) || (!isSapIntegration && isSapIntegrationRequired) ? 'hidden' : 'visible'"
                                  class="icon-basket product__add"
                                  [attr.data-test]="'icon-product-add'"
                                (click)="addProductToCart(product)"></span>
                                <span
                                  appDebounceClick
                                  [ngClass]="{'disabled': !isSapIntegration && isSapIntegrationRequired}"
                                  [style.visibility]="(isSapIntegration && isSapIntegrationRequired) || (!isSapIntegration && !isSapIntegrationRequired)  ? 'hidden' : 'visible'"
                                class="icon-basket product__add"></span>
                              </div>
                            </div>
                          </div>
                        </td>
                      } @else {
                        <td class="loader__overlay product__loader">
                          <span class="loading-animation"></span>
                        </td>
                      }
                    }
                    <td class="width-20 remove-button">
                      <span class="icon-close product__remove"
                        [attr.data-test]="'icon-product-remove'"
                        appDebounceClick
                        [style.visibility]="isItemInProgress(product.sku) ? 'hidden' : 'visible'"
                      (click)="removeItemFromWishlist(product.sku)"></span>
                      @if (isItemInProgress(product.sku)) {
                        <div
                          class="loader__overlay product__loader">
                          <span class="loading-animation"></span>
                        </div>
                      }
                    </td>
                  </div>
                </tr>
              }
            </tbody>
          </table>
          <div class="wishlist__summary" [attr.data-test]="'desc-wishlist-summary'">
            @if (getProductsQty() === 1) {
              {{ 'wishlists.single-product' | translate }}
            } @else {
              {{ 'wishlists.multi-product' | translate: {number: getProductsQty()} }}
            }
            @if (getTotalPrice() > 0 && !isUsStore && !isCaStore) {
              <div class="wishlist__total">
                {{ 'wishlists.total-price' | translate }}
                {{ getTotalPrice() | currency: currency }}
                @if (isExcludeTaxActive()) {
                  <a class="col__tax-disclaimer" [attr.data-test]="'wishlist-total-tax-disclaimer'">
                    ({{ 'app-product-page.ex_gst' | translate }})
                  </a>
                }
              </div>
            }
          </div>
        } @else {
          <div class="empty-wishlist">
            {{ 'wishlists.empty' | translate }}
            <button class="button col-10 empty-cart shopping-cart-continue-shopping-button"
              (click)="redirectToProductLists()">{{ 'shop-cart.continueShopping' | translate }}
            </button>
          </div>
        }
      } @else {
        <div class="loader__content">
          <div class="loading-animation"></div>
        </div>
      }
    </div>
    <app-wishlist-edit
      [name]="wishlist.attributes.name"
      [id]="wishlist.id"
      [showModal]="editModalActive"
      (closeModal)="editModalActive = false"
      (inProgress)="editInProgress = true; editModalActive = false"
      (edited)="wishlistEdited($event)">
    </app-wishlist-edit>
    <app-wishlist-remove
      [wishlist]="wishlist"
      [showModal]="removeModalActive"
      (closeModal)="removeModalActive = false"
      (removed)="wishlistRemoved()">
    </app-wishlist-remove>
    <app-add-item-modal
      [showModal]="addItemToCartModalActive"
      (closeModal)="addItemToCartModalActive = false"
      [items]="items"
      [currentCartId]="currentCartId">
    </app-add-item-modal>
    <app-modal-confirm
      [type]="iconType.WARNING"
      modalTitle="{{ 'catalog.select-equipment-modal.title' | translate }}"
      notifyText="{{ 'catalog.select-equipment-modal.text' | translate }}"
      cancelBtnText="{{ 'catalog.select-equipment-modal.cancel-btn' | translate }}"
      primaryBtnText="{{ 'catalog.select-equipment-modal.submit-btn' | translate }}"
      [showModalConfirm]="showModalSelectEquipment"
      (closeModalConfirm)="showModalSelectEquipment = false"
      (primaryActionConfirm)="selectEquipment()">
    </app-modal-confirm>
  } @else {
    <div class="loader__content">
      <div class="loading-animation"></div>
    </div>
  }
</ng-container>
</app-access-control>
